// extracted by mini-css-extract-plugin
module.exports = {"mobile":"Mobile_mobile__t36h0","close-icon":"Mobile_close-icon__2OB7D","mobile-options":"Mobile_mobile-options__Wus2W","mobile-option":"Mobile_mobile-option__1ht_y"};